import { Box, Grid, IconButton, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ImageLoader from "./ImageLoader";
import CustomText from "./CustomText";
import { openWhatsApp } from "../utils/openWhatsApp";
import {
  FaFacebookF,
  FaInstagram,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box sx={design.Back}>
      <Grid container>
        <Grid item size={design.grid1} />
        {/* Logo */}
        <Grid size={design.GridLogo}>
          <ImageLoader
            src="https://centromedicomedam.com/IMG/centromedicoMEDAM/CentroMedicomedamBlanco.svg"
            alt="Logo MEDAM"
            height={design.heig}
          />
          <CustomText
            color="#FFF"
            fontWeight={400}
            fontFamily="Nunito"
            textAlign="left"
            width="100%"
          >
            <br />
            "Donde la familia es nuestra prioridad"
          </CustomText>

          <Stack direction="row" sx={design.socialMedia}>
            {redesSociales.map((red, index) => (
              <IconButton
                key={index}
                sx={design.IconButton}
                onClick={() => {
                  if (red?.type === "whatsApp") {
                    openWhatsApp(
                      "5959570961",
                      "Hola, me gustaría recibir información sobre sus servicios.",
                      false,
                    );
                    return;
                  }

                  if (red?.url) {
                    window.open(
                      red.url,
                      red.url.startsWith("http") ? "_blank" : "_self",
                    );
                  }
                }}
              >
                {red.icon}
              </IconButton>
            ))}
          </Stack>
        </Grid>
        {/* Sitio */}
        <Grid size={design.Grid} pl={15}>
          <CustomText
            color="#FFF"
            fontWeight={700}
            mb={3}
            fontFamily="Nunito"
            fontSize={24}
            textAlign="Left"
            width="100%"
          >
            Sitio
          </CustomText>

          {Sitio.map((item) => (
            <CustomText
              color="#FFF"
              fontFamily="Nunito"
              fontWeight={400}
              textAlign="left"
              key={item.name}
              sx={design.Link}
              onClick={() => navigate(item.path)}
            >
              {item.name}
            </CustomText>
          ))}
        </Grid>
        {/* Contacto */}
        <Grid
          size={design.Grid}
          pl={10}
          onClick={() => navigate("/como-llegar")}
        >
          <CustomText
            color="#FFF"
            fontWeight={700}
            mb={3}
            fontFamily="Nunito"
            fontSize={24}
            textAlign="Left"
            width="100%"
          >
            Contacto
          </CustomText>

          <CustomText
            color="#FFF"
            fontWeight={400}
            fontFamily="Nunito"
            fontSize={24}
            textAlign="Left"
            width="100%"
            sx={design.Contact}
          >
            Prolongación Benjamín
            <br />
            Robles 47 Texcoco,
            <br />
            Estado de México
            <br />
            Carretera Federal
            <br />
            México-Veracruz
            <br />
            <br />
            Tel. 595 957 0961
          </CustomText>
        </Grid>
        {/* Legales */}
        <Grid size={design.Grid} pl={10}>
          <CustomText
            color="#FFF"
            fontWeight={700}
            mb={3}
            fontFamily="Nunito"
            fontSize={24}
            textAlign="Left"
            width="100%"
          >
            Legales
          </CustomText>

          {Legales.map((item) => (
            <CustomText
              color="#FFF"
              fontFamily="Nunito"
              fontWeight={400}
              textAlign="left"
              key={item.name}
              sx={design.Link}
              onClick={() => {
                if (item.path) navigate(item.path);
              }}
            >
              {item.name}
            </CustomText>
          ))}
        </Grid>
        <Grid item size={design.grid1} />
      </Grid>
      {/* Línea */}
      <Box sx={design.Line} />
      {/* Derechos */}
      <CustomText
        color="#FFF"
        fontWeight={400}
        mb={3}
        fontFamily="Nunito"
        fontSize={15}
        textAlign="center"
        width="100%"
      >
        © Todos los derechos reservados. Centro Médico Medam
      </CustomText>
    </Box>
  );
};

export default Footer;

const design = {
  Back: {
    backgroundColor: "#1B2559",
    width: "100%",
    pt: {
      xs: 6,
      md: 8,
    },
    pb: 4,
  },
  GridLogo: {
    xs: 12,
    sm: 12,
    md: 2.5,
    lg: 2.5,
    xl: 2.5,
  },
  Grid: {
    xs: 6,
    sm: 6,
    md: 2.5,
    lg: 2.5,
    xl: 2.5,
  },
  grid1: { xs: 1, md: 1, lg: 1, xl: 1 },
  Link: {
    fontSize: 16,
    lineHeight: "34px",
    cursor: "pointer",
    transition: ".25s",

    "&:hover": {
      color: "#FFFFFF",
      transform: "translateX(4px)",
    },
  },
  Contact: {
    fontSize: 16,
    lineHeight: "30px",
  },

  Line: {
    width: {
      xs: "92%",
      md: "86%",
    },
    height: "1px",
    margin: "20px auto 25px auto",
    backgroundColor: "#FFF",
  },
  heig: {
    xs: 96,
    sm: 12,
    md: 40,
    lg: 96,
    xl: 96,
  },
  socialMedia: {
    gap: 2,
    mt: 2,
    mb: 2,
  },
  IconButton: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,.12)",
    color: "#FFF",
    transition: "all .25s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,.22)",
      transform: "translateY(-3px)",
    },
  },
};

const Sitio = [
  {
    name: "Inicio",
    path: "/",
  },
  {
    name: "Nosotros",
    path: "/mision-y-vision",
  },
  {
    name: "Servicios",
    path: "/servicios",
  },
  {
    name: "Directorio",
    path: "/directorioMedico",
  },
];

const Legales = [
  {
    name: "Políticas",
    path: "/politicas-del-sitio",
  },
  {
    name: "Aviso de Privacidad",
    path: "/aviso-de-privacidad",
  },
  {
    name: "Términos y condiciones",
    path: "/terminos-de-uso",
  },
];

const redesSociales = [
  {
    icon: <FaInstagram />,
    url: "https://www.instagram.com/centromedico_medam?igsh=ajhiYnFmenJjMXBo",
    type: "instagram",
  },
  {
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/share/19EGRopCww/?mibextid=wwXIfr",
    type: "facebook",
  },
  {
    icon: <FaEnvelope />,
    url: "mailto:contacto@centromedicomedam.com",
    type: "mail",
  },
  {
    icon: <FaWhatsapp />,
    url: null,
    type: "whatsApp",
  },
];
